            /**************************\
            *                          *
            *          COMMON          *
            *                          *
            \**************************/
// GDS&自建融合後放置共同規格地方
export interface NotIncludeObj {
    //設定使用不包含日期
    StartDate: string; //YYYY-MM-DD,
    EndDate: string; //YYYY-MM-DD,
}
export interface IETItem { 
    ItemSeq: string; //品項ID ETItem.ItemSeq
    Name: string; //品項名稱 ETItem.TicketType.TicketName
    Note: string | null; //補充資訊，如歲數身高限制 *自建沒用到但會傳null
    LowQty: number; //最低(初始)數量 ETItem.LowQty
    HighQty: number; //最高訂購數量，預設10
    StartBuyQty: number; //起始購買量 for 自建使用 *GDS LowQty == StartBuyQty
    AllowQty: number | null; //可購買數量 ETItem.AllowQty *GDS沒用到但會傳null
    Ignore: boolean; //扣量狀態，有設定的話 DB就不會管控庫存 *目前未使用
    SalePrice_NonMember: number; //一般售價，也是預設顯示售價
    SalePrice: number; //會員售價
    ListPrice: number; //有刪除線的品項價格（限時折扣時的原價）
    ListCurr: string; //幣別 *目前未使用
    Mutiple: number; //倍數數量 ETItem.Mutiple
    Unit: string; //購買單位(每組、每位、每輛...)
    SalePrice_Spread: number;
    IsForSale: boolean; //是否可販售
    NotForSaleReason: string; //不可販售原因(已完售、補貨中)。IsForSale 為 false 時用來取代"選擇方案"文字
}
export interface ITicketNum {
    [key: string]: number; // 票種與數量
}
export interface ICalendar {
    [key: string]: {
        //*YYYY-MM-DD
        Events: Array<string> | null; //當天可販售場次('3:00','4:00') TODO: *GDS沒用到但會傳null，之後要移出到session API裡
        LowestPrice?: number; // 當日所有品項最低售價 // GDS獨有
        ETItem: Array<IETItem>; // 當日所有票種
    };
}
export interface ISessionItem { //TODO: 之後自建改成打API取得場次再來一起定義
    Session: string; // 場次時間
    SessionUUID: string; // 場次唯一UUID
    LowestPrice: string; // 該場次最低價
    ETItem: Array<IETItem>;
}
// 重置
export interface IresetAllProps{ 
    dispatch: any;
    isTHSR: boolean;
    setTicketNum: any;
    //TODO: GDS獨有
    ExpectedUseDay?: boolean;
    EarliestBuyDay?: string;
    GTempCalendarData?: ICalendar;
    GDetail?: IGDSDetailData;
    session?: ISessionItem[]; //TODO: 之後可能會變成都有
    setCalendar?: any;
    setSessionPicked?: any; //TODO:感覺可以融合?
    setCalenderErr?: any; //TODO:感覺可以融合?
    setSessionErr?: any; //TODO:感覺可以融合?
    setTicketErr?: any; //TODO:感覺可以融合?
    //TODO: 自建獨有
    calendarRef?: any; 
    setScrollTo?: any;
    setPickCalendar?: any;
    NormalFetchData?: INormalPlan;
    setPickSession?: any; //TODO:感覺可以融合?
    setCalendarErrorMsg?: any; //TODO:感覺可以融合?
    setSessionErrorMsg?: any; //TODO:感覺可以融合?
    setTicketErrorMsg?: any; //TODO:感覺可以融合?
}

// 之後GDS跟自建會使用相同的方案list & detail規格
// 方案清單
export interface IPlanList { //TODO:相同於IGDSPlanListData,之後合併時刪除IGDSPlanListData
    // ProductName: string; //產品名稱 for 自建高鐵版 選擇方案顯示用(TODO:已整合到FormatName使用，待刪除)
    TotalLowSalePrice?: number; //方案最低售價 for 自建高鐵版有 ID == Default 選擇方案顯示用 (三階段廢除)
    TotalEarliestBuyDay?: string; //方案最早可預購日 for 自建高鐵版 ID == Default 選擇方案顯示用 (三階段廢除)
    TotalIntroductionArray?: string[]; //*方案介紹 for 自建高鐵版 ID == Default 選擇方案顯示用 (三階段廢除)
    Currency: string; //牌價幣別
    SaleCurrency: string; //售價幣別
    IsPickOneEtitem: boolean; //座位卡控 TODO:相同於IsSeat
	ItemType: string; //產品類別 0:自建 1:GDS
    AdvanceTime: string; //預先曝光
    Format: IPlanList_Format[];
}
export interface IPlanList_Format { //TODO:相同於IFormat,之後合併時刪除IFormat
    FormatName: string; //方案名稱
    FormatID: string; //方案ID
    ExpectedUseDay: boolean; //需預計使用日，為true則需要日曆
    EarliestBuyDay: string; //最早可預購日
    LowListPrice: number; //*此方案的品項內，預設最低牌價
    LowSalePrice: number; //*此方案的品項內，預設最低售價
    IntroductionArray: string[]; //*方案介紹
    THSRspec?: string | null; // 搭配高鐵設定(高鐵聯票新增) Ex: '0' | '1' | null,  0:自選加購  1:一定要加購  null:不開放加購,沒有高鐵聯票也是 FIXME: 待高鐵API調整完後刪除
    THSRTripType?: string | null; // (高鐵聯票新增) ex: '0' | '1',  0:只賣單程  1:都賣  null:無售 FIXME: 待高鐵API調整完後刪除
    IsForSale: boolean; //是否可販售
    NotForSaleReason: string; //不可販售原因(已完售、補貨中)。IsForSale 為 false 時用來取代"選擇方案"文字
}
export interface IListProps { //TODO:相同於IGDSPlanProps,之後合併時刪除IGDSPlanProps
    data?: IPlanList_Format;
    Currency: string;
    SaleCurrency: string;
    listIndex: number; // 各清單index
    changeTotalIsInStock?: any; // 含高鐵產品M版 選擇品項後修改TotalIsInStock的功能
    isCrossell?: boolean;
}
// 方案內容
export interface IPlanDetail { //TODO:INormalPlan融合IGDSDetailData，之後要刪除IGDSDetailData
    Tags?: Array<{
        //關於此方案標籤
        Type: string; //*標籤類型 有固定的幾種標籤名字，如cancel、confirm
        Text: string; //*標籤文字
    }>;
    NotIncludeDate: Array<NotIncludeObj>;
    CalendarDate: ICalendar;
    EarliestBuyDay: string | null; //今日往後推算幾日為最早可預購日
    LastBuyDay: string | null; //品項最晚可使用日
    ETItem: Array<IETItem>;
    Sessions: boolean; // 用於判斷這是否是有場次類型的產品
    UseExpire: string; //使用效期 ETSingle[0].UseExpire *自建沒用但一樣會傳值
    AgeLimit: string; //適用年齡 ETItem.Note.gds:age_limit *自建沒用到但會傳null
    Specifications: string | null; //產品規格 ETItem.Note.gds:description *自建沒用到但會傳null
    Instructions: string; //憑證使用 Instructions - 改成回傳文字，非原本數字
    IsModifyOrder: boolean; //是否可取消 ETItem.IsModifyOrder
    CancelPolicy: string | null; //取消政策 *自建沒用到但會傳null
    ETItemHighQty: number | null; //用於判斷品項的總數上限 *自建沒用到但會傳null
    ETItemLowQty: number | null; //用於判斷品項的總數下限 *自建沒用到但會傳null
    ETItemMutiple: number | null; //用於判斷品項的倍數 *自建沒用到但會傳null
}
export interface IStoredPlanDetail {
    listID: string;
    listDetail: IPlanDetail;
    hasCalendar: boolean; // 是否是有月曆的產品
}
// 月曆切換月份時是否打API的判斷
export interface IalreadyFetchedMonth { 
    [key: string]: string[]; // 品項ID: [已使用月份] / FormatID: ['YYYY-MM','YYYY-MM']
}

//CALL API 打方案detail時的要求資料 TODO:相同於apiCall.ts裡的IfetchGDSDetailData,待GDS融合後刪除IfetchGDSDetailData
export interface IfetchDetailData {
    ETID: string;
    EarliestBuyDay: string;
    ExpectedUseDay: boolean;
    FormatID: string;
    isTHSR: boolean;
    DetailFetchMonths?: {[key: string]: string[]};
    context: {
        DetailFetchAllData: any;
        setDetailFetchAllData: any;
        setDetailLoadingFail: any;
        setDetailFetchFailMsg: any;
        setDetailData: any;
        setTempCalendarData: any;
        setIsDetailLoading: any;
        setDetailFetchMonths?: any;
        ThsrRoundType: number | null; // IT判別是單雙程還是全品項面板 (0:單 / 1:雙 / null:Default)
        // TODO:待第三階段場次移出再將?移除----
        setAllSessions?: any;
        setPickSession?: any;
        setIsSessionLoading?: any;
        setSessionLoadingFail?: any;
        // ----------------------
        setPickCalendar?:any;
    };
    dispatch?: any;
}
// 元件
export interface IValidateItem { // 驗價API回傳的資料格式 (IT之後會新增價格驗證)
    IsSuccess: boolean; // 是否通過驗證
    Title: string; // 提示光箱的標題
    ErrMessage: string; // 錯誤時出現在重整提示光箱的內容
}
export interface IOnSubmit { // onSubmit元件共同規格
    (type: 'checkData' | 'redirect'): (Promise<{
        selectChecked: boolean; // 是否通過onSubmit內的驗證
        apiChecked: IValidateItem | {}; // api回傳的資料 若前面驗證(月曆、場次、票種)就失敗，則直接回傳空物件
    }> | void)
}
export interface ICommonDetailInfo { // DetailInfo元件共同規格
    dialogSwitch?: { [key: string]: boolean }; //對話框光箱State
    setDialogSwitch?: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>; //對話框光箱狀態更改action
    isCrossell?: boolean
}

            /**************************\
            *                          *
            *           GDS            *
            *                          *
            \**************************/
export interface IGDSPlanListData { // TODO: IGDSPlanListData被IPlanList取代，之後要替換
    Currency: string; //牌價幣別
    SaleCurrency: string; //售價幣別
    LaunchDate: string; //上架日期
    AdvanceTime: string; //預先曝光
    Format?: IFormat[];
}
export interface IFormat { //TODO: 融合於IPlanList_Format,之後合併時刪除
    FormatName: string; //方案名稱
    FormatID: string; //方案ID
    ExpectedUseDay: boolean; //需預計使用日，為true則需要日曆
    StartDate: string; //設定使用日期
    EndDate: string; //設定使用日期迄
    EarliestBuyDay: string; //*今日往後推算幾日工作日為最早可預購日
    LowListPrice: number; //*此方案的品項內，預設最低牌價
    LowSalePrice: number; //*此方案的品項內，預設最低售價
    IntroductionArray?: string[]; //*方案介紹
    THSRspec?: string; // 搭配高鐵設定(高鐵聯票新增) Ex: '0' | '1' | null,  0:自選加購  1:一定要加購  null:不開放加購,沒有高鐵聯票也是
    THSRTripType?: string; // (高鐵聯票新增) ex: '0' | '1',  0:只賣單程  1:都賣  null:無售
    IsForSale: boolean; //是否可販售
    NotForSaleReason: string; //不可販售原因(已完售、補貨中)。IsForSale 為 false 時用來取代"選擇方案"文字
}
export interface IalreadyFetchedGDSMonth { //TODO: 融合於IalreadyFetchedMonth, 之後刪除
    // GDS月曆切換月份判斷是否打API
    [key: string]: string[]; // 品項ID: [已使用月份] / FormatID: ['YYYY-MM','YYYY-MM']
}

export interface IGCalendarData { //TODO: 融合於ICalendar, 之後刪除
    [key: string]: {
        //*YYYY-MM-DD
        LowestPrice?: number; // 當日所有品項最低售價
        ETItem: Array<IETItem>; // 當日所有票種
    };
}
export interface IGDSDetailData { //TODO:被IPlanDetail取代，之後要刪除
    Tag?: { Type: string; Text: string }[]; //關於此方案標籤
    NotIncludeDate?: Array<NotIncludeObj>;
    EarliestBuyDay: string; //*今日往後推算幾日為最早可預購日
    LastBuyDay: string; //*品項最晚可使用日
    CalendarDate: IGCalendarData;
    ETItem: Array<IETItem>;
    Sessions: boolean; // 用於判斷這是否是有場次類型的產品
    UseExpire?: string; //使用效期 ETSingle[0].UseExpire
    AgeLimit?: string; //適用年齡 ETItem.Note.gds:age_limit
    Specifications?: string; //產品規格 ETItem.Note.gds:description
    Instructions?: string; //*憑證使用 Instructions - 改成回傳文字，非原本數字
    IsModifyOrder?: boolean; //是否可取消 ETItem.IsModifyOrder
    CancelPolicy?: string; //*取消政策
    ETItemHighQty?: number; //用於判斷品項的總數上限
    ETItemLowQty?: number; //用於判斷品項的總數下限
    ETItemMutiple?: number; //用於判斷品項的倍數
}
export interface IGDSDetailStore { //TODO:被IStoredPlanDetail取代，之後要刪除
    listID: string;
    listDetail: IGDSDetailData;
    hasCalendar: boolean; // 是否是有月曆的產品
}
export interface IGDSDetailInfoProps { //TODO:融合階段再考慮用途 => 沒用到
    detailData: IGDSDetailData;
    listData: IFormat;
}
export interface IGDSPlanProps { //TODO:IListProps取代，之後要刪除
    data: IFormat;
    Currency: string;
    SaleCurrency: string;
    listIndex: number; // 各清單index
    isCrossell?: boolean;
    AdvanceTime: string; //預先曝光
}
export interface IGDSSessionItem { //TODO: 相同於ISessionItem , 之後融合刪除
    Session: string; // 場次時間
    SessionUUID: string; // 場次唯一UUID
    LowestPrice?: string; // 該場次最低價
    ETItem?: Array<IETItem>;
}
export interface IresetAllGDSProps { //TODO: 融合於IresetAllProps, 之後刪除
    dispatch: any;
    isTHSR?: boolean;
    ExpectedUseDay: boolean;
    EarliestBuyDay: string;
    GTempCalendarData: IGCalendarData;
    GDetail: IGDSDetailData;
    session: IGDSSessionItem[];
    setTicketNum: any;
    setCalendar: any;
    setSessionPicked: any;
    setCalenderErr: any;
    setSessionErr: any;
    setTicketErr: any;
}
            /**************************\
            *                          *
            *           NORMAL         *
            *                          *
            \**************************/
// TODO: INormalPlan會被取代成 IPlanDetail
export interface INormalPlan {
    ProductName?: string; // 產品名稱
    Currency: string; //牌價幣別
    SaleCurrency: string; //售價幣別
    LowListPrice?: number; //最低牌價
    LowSalePrice?: number; //*最低售價
    EarliestBuyDate: string; //*最早可預購日
    AdvanceTime: string; //預先曝光
    StartDate: string; //設定使用日期起(在今日之後則為預購)
    EndDate: string; //設定使用日期迄
    Introduction?: Array<string>; //*方案介紹 - 規劃中，可能會調整資訊來源
    IsSeat?: boolean;
    Tags?: Array<{
        //關於此方案標籤
        Type: string; //*標籤類型 有固定的幾種標籤名字，如cancel、confirm
        Text: string; //*標籤文字
    }>;
    Calendar?: ICalendar;
    ETItem: Array<IETItem>;
    UseExpire?: string; //使用效期
    AgeLimit?: string; //適用年齡
    Specifications?: string; //**產品規格
    // 前三項為 HTML 欄位，再透過篩選標籤拆出欄位
    Instructions?: string; //* 憑證使用 - 改成回傳文字，非原本數字
    IsModifyOrder: string; //是否可取消,自建產品是取消政策文字
}

// TODO: 目前統一到IETItem,確定沒問題之後要刪除
export interface INormalETitem {
    ListPrice: number; //有刪除線的品項價格（限時折扣時的原價）
    ItemSeq: string; //品項ID ETItem.ItemSeq
    Name: string; //品項名稱 ETItem.TicketType.TicketName
    // Note: string; //*補充資訊，如歲數身高限制 
    LowQty?: number; //最低應購數量 ETItem.LowQty
    HighQty?: number; //*最高訂購數量，預設10
    AllowQty?: number; //*可購買數量 ETItem.AllowQty 
    Ignore: boolean; //扣量狀態 
    SalePrice_NonMember: number; //*一般售價，也是預設顯示售價
    SalePrice: number; //*會員售價
    Mutiple?: number; //倍數數量 ETItem.Mutiple
    Unit?: string; //購買單位(每組、每位、每輛...)
    THSRspec?: string; // 搭配高鐵設定(高鐵聯票新增) Ex: '0' | '1' | null,  0:自選加購  1:一定要加購  null:不開放加購,沒有高鐵聯票也是
    THSRTripType?: string; // (高鐵聯票新增) ex: '0' | '1',  0:只賣單程  1:都賣  null:無售
}

export interface ITicketBlockProps { //TODO: 目前有被引入定義,若最後要刪除要去組件刪除引入
    // TODO: 有時間再定義
    isCrossell?: boolean;
}
export interface ISessionBlockProps { //TODO: 目前有被引入定義,若最後要刪除要去組件刪除引入
     // TODO: 有時間再定義
}
export interface INormalPlanProps { //TODO:IListProps取代，之後要刪除
    // ETID: string;
    // data: INormalPlan;
    // fetchAnotherMonthData?: (YYYYMM: string) => void;
}

            /**************************\
            *                          *
            *           THSR           *
            *                          *
            \**************************/
// 方案選擇區塊
export enum Area {
    THSR = 'THSR', // 高鐵區塊
    Origin = 'Origin', // 非高鐵區塊方案
    None = 'None', // 未選擇
}
// 是否可搭配高鐵購買
// null:不開放加購,沒有高鐵聯票也是
export enum TSpec {
    optional = '0', // 搭不搭高鐵都可
    must = '1', // 必搭高鐵
}
// 高鐵單回程種類
export enum TTripType {
    oneway = '0', // 單程
    round = '1', // 舊版定義:來回單程都賣，新版:表示為來回 TODO: GDS更新後會刪除舊版定義
}
// 高鐵步驟
export enum TStep {
    first = 0, // 打開高鐵面板
    second = 1, // 挑選完車次，繼續挑選票券
}
export type ITHSROpenedPanel = TTripType.oneway | TTripType.round;
export type toView = 'calendar' | 'session' | 'ticket' | null;
export enum scrollToRef {
    calender = 'calendar',
    session = 'session',
    ticket = 'ticket',
    submitErr = 'submitErr',
}
export interface IDiscountOff {
    eventName: string; // 活動名稱 ex: "測試用常態高鐵75折"
    percentOff: number; // 折扣百分比 ex: 25 => 25 percent off(75折)
    buyDates: [ // 符合此折扣優惠的購買日期，如果多個區間則根據需求回傳多區間物件
        {
        startDate: string; // 最早可購買日期 ex: "2023-01-01"
        endDate: string; // 最晚可購買日期 ex: "2023-01-31"
        }
    ],
    aboardDates: [ // 符合上述購買日期條件下，享有折數優惠的搭乘日期，如果多個區間則根據需求回傳多區間物件
        {
        startDate: string; // 最早可搭乘日 ex: "2023-01-01"
        endDate: string; // 最晚可搭乘日 ex: "2023-01-31"
        }
    ]
}
export interface IThsrTripInfo {
    ThsrType: string; // ex: "0" | "1",  "0":單程  "1":來回
    ProjectName: string; // 高鐵面板標題 ex:"高鐵國旅聯票 | 單程票"
    ThsrDisPercentName: string;  // 高鐵標題現折文字 ex: "高鐵75折起"
    ProjectDisMemo: Array<string>; // 高鐵面板注意事項 ex:["01/01~01/31 測試用常態高鐵75折 ▼下單享75折，限01/01~01/31搭乘。","02/01~04/30高鐵國旅聯票周年慶  車票75折起▼下單享75折，限02/13~02/15搭乘。"]
    ProductItemNames: Array<string>; // 高鐵面板適用品項列表
    ThsrWayPrice: {
        LowListPrice: number; // 單/雙程原始售價 ex: 3176
        LowSalePrice: number; // 單/雙程最低售價 ex: 2710
    };
    DiscountOff?: IDiscountOff[]; // 限折詳細資訊 FIXME: 待棄用，改成ThsrDiscountDate & HighestDiscountOff
    ThsrDiscountDate: [ // 當日超過基本折扣之限折資料 (目前 percentOff > 15 才會傳，沒有則為[])
        {
            Date?: string; // 可搭乘日期
            percentOff?: number; // 折扣百分比
        }
    ];
    HighestDiscountOff: number; //當日最高可折扣百分比 ex: 25 => 25 percent off(75折)

    /*
    * 產品中有單/雙程的品項/方案列表(ID == Default也適用)
    * 跟原本的list Format差別在只有含綁高鐵的產品品項/方案
    * 高鐵面板的品項/方案列表都統一從這邊拿(避免產品沒有default面板導致list Format為空陣列)
    */
    ProductItemListFormat: IPlanList_Format[];

    /*
    * 票券所屬區域(用於比對票券所屬區域，這樣方案明細須新增關於區域參數) Ex: 要統一開在這裡還是回歸既有GDS跟自建API?
    * 需回傳產品所屬的車站(用於判斷是否選擇到票券目的地進而控制出發地目的地高鐵站選項)
    * 但如果票券所屬地沒有高鐵站，回傳規定之鄰近縣市高鐵站(高鐵規範?)
    */
    ProductAreaID: Array<string>; // Ex: ["TAO", "KHH"] 產品區域可能會有多目的地

    // 用於限縮原始票券可使用日期
    StartDate: string; // 此產品高鐵可選最早日期 ex: "2021-07-01"
    EndDate: string; // 此產品高鐵可選最晚日期 ex: "2021-08-01"
}
export interface ITHSRInitData {
    HasTHSR: boolean; // 是否有高鐵聯票之產品 ex: true

    // 如有選來回，預計回程日可選日期為出發日往後日數規則(高鐵規範)
    MaxReturnDays: number; // ex: 3, 假設 2021-07-01 出發則回程日只可選到3天後 2021-07-04

    SaleCurrency: string; // 售價幣別 ex: "TWD"
    TrainTickets: Array<{
        text: string; // 票種 ex: "全票"  SelectTicketNo: ttypeName?
        value: string; // 票種ID ex: "Adt"  "Chd"  "Con" ??
        LowQty: number; // 最低應購數量 ex: 0
        HighQty: number; // 最高訂購數量 ex: 10
    }>;
    EstimateDepartTimes: Array<{ // 預計出發時間可選選項
        text: string; // 預計出發時間 ex: "05:30"
        value: string; // 預計出發時間Value ex: "0530"
    }>;
    TicketRule: {
        TotalMaxQty: number; // 高鐵票可購買總數上限，ex: 10
    };
    ThsrTripInfos: IThsrTripInfo[]; // 單雙程面板個別資訊
}
export interface ITrainItem {
    TrainClass: string; // 車廂種類 Y: 標準車廂 J: 商務車廂
    TrainNumber: string; // 班次 ex: "0050"
    DepartTime: string; // 發車時間 ex: "06:15"
    ArriveTime: string; // 到站時間 ex: "08:40"
    Duration: string; // 車程 ex: "2小時25分"
}

export interface ITHSRDetailData {
    Rounds: Array<{
        DepartStation: {
            text: string; // 各趟起站 ex: "台北"
            value: string; // 各趟起站 ex: "TPE"
        };
        ArriveStation: {
            text: string; // 各趟迄站 ex: "高雄"
            value: string; // 各趟起站 ex: "KHH"
        };
        DepartDate: string; // 發車日期 ex: "2021-07-01"

        TrainItems: ITrainItem[];
    }>;
}
export interface ITHSRInfoData {
    DiscountRule: number;
    ThsrDiscountPrice: number;
    Thsr_OrgCurr_DiscountPrice: number;
    ProductUseDate: Array<string>;
    TicketsInfo: {
        Erat: number; // 高鐵幣別(預設台幣)轉換前台幣別之匯率
        ThsrDiscountPrice: number;
        Thsr_OrgCurr_DiscountPrice: number;
        adultPrice?: number; // 成人單價(如果是來回就來回加總)
        adult_OrgCurr_Price: number; // 成人票原幣別單價(如果是來回就來回加總)
        concessionPrice?: number; // 優惠票單價(如果是來回就來回加總)
        concession_OrgCurr_Price: number; // 優惠票原幣別單價(如果是來回就來回加總)
        headCounts: number;
        totalPrice: number;
        total_OrgCurr_Price: number; // 搜尋條件之票價原幣別總和
    };
}
export interface IListStatus {
    onewayQty: number;
    roundQty: number;
    originQty: number;
}
interface THSRSeatInfo {
    [key: string]: number;
}
export interface THSRSearchOption {
    startDate: string;
    endDate: string;
    startTime: number;
    endTime: number;
    destination: string;
    departure: string;
    seatClass: string;
    seatInfo: THSRSeatInfo;
}
